module Meevo.Plugins.TechSphere {
    "use strict";

    /**
    * Main Section of Field Labels
    */
    export class MainSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        protected workActivityDetail: Model.DataDetail = {};


        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            private modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey)
        }

        activate(): void {
            super.activate();
            this.workActivityDetail.displayName = this.model.workActivityDisplayName || null;
        }

        updateWorkActivity() {
            if (this.workActivityDetail) {
                this.model.workAcivityId = this.workActivityDetail.id;
                this.model.workActivityDisplayName = this.workActivityDetail.displayName;
            }

        }

    }
}